import { versionedHttpCollection } from "us.helper/http/collection";

export const extendedFields = {
  get: async (): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "entityservice",
          `debtor/otherinfometadata`,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  save: async (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.post(
          "entityservice",
          `extendedfield`,
          params,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteField: async ({ fieldId }: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.delete(
          "entityservice",
          `extendedfield`,
          fieldId,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  getDataTypes: async (): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "entityservice",
          `extendedfields/datatypes`,
          {},
          "v1"
        );
        resolve({
          data,
          status,
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  getSPList: async (): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "bmdservice",
          `datatypestoredprocedures`,
          {},
          "v1"
        );
        resolve({
          data,
          status,
        });
      } catch (error) {
        reject(error);
      }
    });
  },
};
